/* ══ v16.5 (c): SEARCH ON THE PORTFOLIO AND PROGRAMME LEVELS ═══════════════════════════════
   His ask: "a way to search for projects and programs when I am on the level where I see all
   programs or within a program... bit like in Actions or in minutes."
   ⚠ ONE FIELD THAT KNOWS WHICH LEVEL IT IS ON (◆c-1), not two. Two fields is the shape that
   jumps: each would live in its own view and the pair would trade places as you move.
   ⚠ NAME ONLY (◆c-2) - plain case-insensitive substring, matching the Actions search rather
   than inventing a third behaviour. The visible id is included because it is now a thing he
   quotes: typing PRGM-02 should find it.
   ⚠ IT CLEARS ON EVERY LEVEL CHANGE (◆c-3). A filter left applied to a list you have navigated
   away from is exactly the "which filter is hiding it" trap v14.2 (d) exists to prevent - and
   one level up it would be worse, because a hidden PROGRAMME looks like a deleted programme.
   ⚠ AND IT SAYS SO WHEN IT HIDES THINGS. A count of what the filter is holding back is printed
   beside the list; an empty result never leaves a blank pane with no explanation. */
let _hdrQuery = "";
let _pfSearchShowArchived = false;   /* session-only; reset whenever the query/level changes */
function _hdrMatch(text) {
  const q = _hdrQuery.trim().toLowerCase();
  if (!q) return true;
  return String(text || "").toLowerCase().indexOf(q) !== -1;
}
/* Which list the field is pointed at right now - derived from the view, never stored, so it
   cannot disagree with what is on screen. */
function _hdrSearchLevel() {
  const c = document.body.classList;
  if (c.contains("view-portfolio")) return "portfolio";
  if (c.contains("view-overview")) return "programme";
  return null;
}
function hdrSearchInput(v) {
  const next = String(v == null ? "" : v);
  if (next !== _hdrQuery) _pfSearchShowArchived = false;
  _hdrQuery = next;
  const x = document.getElementById("hdrSearchClear");
  if (x) x.hidden = !_hdrQuery;
  const lvl = _hdrSearchLevel();
  if (lvl === "portfolio") renderPortfolio();
  else if (lvl === "programme" && typeof renderOverview === "function") renderOverview();
}
function hdrSearchClear() {
  const el = document.getElementById("hdrSearch");
  if (el) el.value = "";
  hdrSearchInput("");
}
/* Show it only where there is a list to filter, and RESET it whenever the level changes.
   ⚠ Hidden with [hidden], not removed, and it sits left of the theme toggle inside the
   right-aligned group - so the toggle cannot move when it appears or disappears. */
function _hdrSearchSync() {
  const wrap = document.getElementById("hdrSearchWrap");
  if (!wrap) return;
  const lvl = _hdrSearchLevel();
  const want = (lvl === "programme" || (lvl === "portfolio" && _pfPane === "programmes"));
  /* ⚠ v16.5 (c): ONLY A MOVE BETWEEN TWO KNOWN LEVELS CLEARS. The first version compared against
     an undefined _lvl, so the very first sync read as a level change and WIPED the query it had
     just been handed - typing filtered nothing at all. Caught by the check, not by reading. */
  const _known = (wrap._lvl !== undefined);
  if (wrap._lvl !== lvl) {
    wrap._lvl = lvl;
    _pfSearchShowArchived = false;
    if (_known && _hdrQuery) {   /* ◆c-3: never carry a filter across a level change */
      _hdrQuery = "";
      const el = document.getElementById("hdrSearch"); if (el) el.value = "";
      const x = document.getElementById("hdrSearchClear"); if (x) x.hidden = true;
    }
  }
  wrap.hidden = !want;
  const el = document.getElementById("hdrSearch");
  if (el) el.placeholder = (lvl === "portfolio") ? "Search portfolio…" : "Search projects…";
}

function pfToggleSearchArchived() {
  _pfSearchShowArchived = !_pfSearchShowArchived;
  renderPortfolio();
}

function _pfProjectHitHtml(C, P, archivedMatch) {
  const projectArchived = !!C.archived;
  const parentArchived = !!P.archived;
  const unavailable = projectArchived || parentArchived;
  const eid = _escapeHtml(C.id);
  const idHtml = _dispId('PRJ', C)
    ? `<span class="disp-id">${_escapeHtml(_dispId('PRJ', C))}</span>` : '';
  const reason = parentArchived ? 'Programme archived · Restore programme first'
    : projectArchived ? 'Archived project · Restore from the project menu' : 'Project';
  const progress = _overallProjectProgress(C);
  const menu = (projectArchived && !parentArchived)
    ? `<div class="pm-menu-wrap"><button class="ov-card-menu-btn pm-menu-btn" data-id="${eid}"`
      + ` onclick="toggleCardMenu(event, this.dataset.id, 'portfolio-project')" title="Manage project" aria-label="Manage project">`
      + `<svg viewBox="0 0 16 16" width="15" height="15"><circle cx="3" cy="8" r="1.45"/><circle cx="8" cy="8" r="1.45"/><circle cx="13" cy="8" r="1.45"/></svg>`
      + `</button><div class="ov-card-menu" id="pfProjectMenu-${eid}" hidden></div></div>` : '';
  return `<div class="pf-project-hit${unavailable ? ' pf-project-hit-arch' : ''}${archivedMatch ? ' pf-search-archive-hit' : ''}"`
    + ` data-project-id="${eid}" data-project-uid="${_escapeHtml(String(C.uid || ''))}" data-programme-id="${_escapeHtml(P.id)}"`
    + (unavailable ? '' : ` role="button" tabindex="0" onclick="_pfProjectActivate(event,this)" onkeydown="_pfProjectActivate(event,this)"`)
    + `><span class="pf-project-hit-mark" aria-hidden="true">↳</span>`
    + `<div class="pf-project-hit-main"><div class="pf-project-hit-name">${idHtml}${_escapeHtml(C.name || 'Untitled project')}</div>`
    + `<div class="pf-project-hit-meta">${_escapeHtml(reason)}</div>`
    + `<div class="pf-project-progress"><span>Overall progress:</span><strong>${_progressValueText(progress.percent)}</strong>`
    + (progress.source === 'assessment' ? `<span class="progress-assessed">Assessed</span>` : '')
    + _progressHelpButtonHtml(C) + `</div></div>`
    + menu + `</div>`;
}

/* v17.2 W1: one result model over the existing flat programme/project arrays. Matching is still
   the established case-insensitive substring rule; grouping is render-only and never builds or
   saves an index. A project with an archived parent is unavailable even when its own flag is live. */
function _pfSearchResultsHtml(programmes) {
  const db = window.__DB__;
  programmes = _listOrderOrdered(programmes, 'programme', '');
  const projects = (db && Array.isArray(db.projects)) ? db.projects : [];
  const liveProgrammeTotal = programmes.filter(P => P && !P.archived).length;
  const liveProjectTotal = projects.filter(C => {
    if (!C || C.archived) return false;
    const P = programmes.find(x => x && x.id === C.programmeId);
    return !!(P && !P.archived);
  }).length;
  let liveProgrammeMatches = 0, liveProjectMatches = 0, archivedMatches = 0;
  const model = programmes.filter(Boolean).map(P => {
    const programmeMatch = _hdrMatch((P.name || '') + ' ' + _dispId('PRGM', P));
    const childMatches = _listOrderOrdered(projects.filter(C => C && C.programmeId === P.id
      && _hdrMatch((C.name || '') + ' ' + _dispId('PRJ', C))), 'project', P.id);
    const liveChildren = childMatches.filter(C => !P.archived && !C.archived);
    const archivedChildren = childMatches.filter(C => P.archived || C.archived);
    if (programmeMatch) {
      if (P.archived) archivedMatches++; else liveProgrammeMatches++;
    }
    liveProjectMatches += liveChildren.length;
    archivedMatches += archivedChildren.length;
    return { P, programmeMatch, liveChildren, archivedChildren };
  });

  const groups = [];
  model.forEach(x => {
    const liveGroup = !x.P.archived && (x.programmeMatch || x.liveChildren.length);
    const archivedGroup = _pfSearchShowArchived
      && ((x.P.archived && x.programmeMatch) || x.archivedChildren.length);
    if (!liveGroup && !archivedGroup) return;
    const programmeIsArchivedMatch = x.P.archived && x.programmeMatch;
    const children = [];
    if (liveGroup) x.liveChildren.forEach(C => children.push(_pfProjectHitHtml(C, x.P, false)));
    if (_pfSearchShowArchived) x.archivedChildren.forEach(C => children.push(_pfProjectHitHtml(C, x.P, true)));
    groups.push(`<div class="pf-search-group" data-programme-id="${_escapeHtml(x.P.id)}">`
      + _pfRowHtml(x.P, programmeIsArchivedMatch ? 'pf-search-archive-hit' : '')
      + children.join('') + `</div>`);
  });

  const liveMatches = liveProgrammeMatches + liveProjectMatches;
  const hidden = Math.max(0, liveProgrammeTotal + liveProjectTotal - liveMatches);
  const hiddenNote = hidden
    ? `<div class="pf-search-note">${hidden} live record${hidden === 1 ? '' : 's'} hidden by your search`
      + ` <button type="button" class="pf-search-clear" onclick="hdrSearchClear()">Clear</button></div>` : '';
  const archivedNote = archivedMatches
    ? `<div class="pf-search-archive-note"><button type="button" class="pf-search-archive-toggle"`
      + ` aria-expanded="${_pfSearchShowArchived ? 'true' : 'false'}" onclick="pfToggleSearchArchived()">`
      + `${archivedMatches} archived match${archivedMatches === 1 ? '' : 'es'} — ${_pfSearchShowArchived ? 'Hide' : 'Show'}</button></div>` : '';
  const empty = liveMatches ? ''
    : `<div class="pf-empty">No programme or project matches “${_escapeHtml(_hdrQuery.trim())}” in live records.</div>`;
  const list = groups.length ? `<div class="pf-list">${groups.join('')}</div>` : '';
  const summary = liveProgrammeMatches + ' programme' + (liveProgrammeMatches === 1 ? '' : 's')
    + ' · ' + liveProjectMatches + ' project' + (liveProjectMatches === 1 ? '' : 's') + ' match';
  return { html: hiddenNote + archivedNote + empty + list, summary };
}

function _portfolioLastSavedHtml() {
  return `Last saved ${_lastSavedSpanHtml('portfolioLastSavedDisplay')}<br>`;
}
function renderPortfolio() {
  const host = document.getElementById('portfolioView');
  if (!host) return;
  const search = document.activeElement;
  const retainSearch = search && search.id === 'actSearch' && _pfPane === 'activity'
    && document.body.classList.contains('view-portfolio');
  /* Keep the composing DOM alive during a late log read; compositionend renders its results. */
  if (retainSearch && search._actComposing) return;
  const selection = retainSearch ? [search.selectionStart, search.selectionEnd, search.selectionDirection] : null;
  _hdrSearchSync();   /* v16.5 (c) */
  _pfPruneExpansion();
  const _all = _listOrderOrdered(_programmes(), 'programme', '');
  const _searching = !!_hdrQuery.trim();
  /* v16.5 (c): name OR the visible id, because PRGM-02 is now a thing he quotes. */
  const list = _all.filter(P => _hdrMatch((P.name || '') + ' ' + _dispId('PRGM', P)));
  const _hiddenBySearch = _all.length - list.length;
  /* v12.1 (W1): live rows, then the archived ones behind the toggle */
  const live = list.filter(P => !P.archived), arch = list.filter(P => P.archived);
  const archHtml = (_pfShowArchived && arch.length)
    ? `<div class="pf-arch-head">Archived</div>` + arch.map(function (P) { return _pfProgrammeGroupHtml(P); }).join('')
    : '';
  /* ⚠ v14 (W8, ◆3): the empty state must not invite work that cannot be saved. FOUND BY LOOKING
     AT THE SCREENSHOT, not by any of the 181 checks: the read-only viewer rendered "use + New
     programme above to create your first one" directly beneath a banner saying saving was off.
     Two opposite instructions on one screen, and the inviting one was the lie. */
  /* ⚠ v16.5 (c): SAY WHAT THE FILTER IS HIDING. v14.2 (d)'s rule - an item missing because of a
     filter looks identical to an item that was deleted, and one level up that is a missing
     PROGRAMME, which is alarming. The count is stated, with a way out. */
  const _searchNote = _hiddenBySearch
    ? `<div class="pf-search-note">${_hiddenBySearch} hidden by your search`
      + ` <button type="button" class="pf-search-clear" onclick="hdrSearchClear()">Clear</button></div>`
    : '';
  const _searchResults = _searching ? _pfSearchResultsHtml(_all) : null;
  const listHtml = _searchResults ? _searchResults.html : (live.length || archHtml)
    ? `${_searchNote}<div class="pf-list">${live.map(function (P) { return _pfProgrammeGroupHtml(P); }).join('')}${archHtml}</div>`
    : (_hdrQuery.trim()
        ? `${_searchNote}<div class="pf-empty">No programme matches “${_escapeHtml(_hdrQuery.trim())}”.</div>`
    : `<div class="pf-empty">No programmes yet — use <strong>+ New programme</strong> above to create your first one.</div>`);
  /* ── v10.5.1 (W1), kept: the binding mechanism belongs HERE too ─────────────────────
     ◆2 sends an unrestorable handle to this view, so this is where the reason and the
     recovery have to be. Before v10.5.1 the user landed here with no explanation, no
     control, and Save silently blocked. Same renderers as the overview, never a copy. */
  /* v14.3 (a): the panes share this render, so the switch, the title and the toolbar
     stay one thing rather than screens that can drift apart. v14.4 (a): three panes now. */
  const _act = (_pfPane === 'activity');
  const _ci = (_pfPane === 'improvement');
  const _progs = !_act && !_ci;
  /* ⚠ v14.4 (b): the header is TWO ROWS — his screenshots of v14.3 in real use. Row 1: title +
     the meta block, the two things that never change with the pane. Row 2: the pane switch
     LEFT-ANCHORED at the container edge (an anchor cannot move when neighbours appear and
     disappear — inside the old right-aligned toolbar its position depended on how many buttons
     rendered beside it, so it JUMPED between panes and got CLIPPED at his window width), then
     the action buttons right-aligned after it. */
  host.innerHTML = `<div class="pf-wrap"><div class="pf-head"><div class="ov-head-text">`
    + `<div class="ov-title">${_act ? 'Activity' : _ci ? 'Continuous improvement' : 'Programmes'}</div>`
    + `<div class="ov-sub">${_act ? 'every change anyone has saved, newest first' : _ci ? 'what worked and what didn’t, from every programme and project' : (_searchResults ? _searchResults.summary : (list.length + ' in this portfolio'))}`
    + (_progs ? `<span class="ov-info-i" title="Everything lives on the FlightDeck server — this portfolio, its programmes and all their projects. Switching programmes is instant. Each Save publishes only the records you changed." onclick="event.preventDefault();event.stopPropagation()">i</span>` : ``)+`</div>`
    + `</div>`
    /* The portfolio is the only level that shows the app version. SD-01 uses the same confirmed
       loaded-portfolio savedAt at all three levels; a missing or unusable stamp renders a dash. */
    /* v14 (W6): "As of" → "Last saved" (label only). ⚠ And with parts the DATE SOURCE question
       §v14 left for this wave is already answered in code: mergeParts sets the merged `savedAt`
       to the NEWEST across every part, so this reads the freshest save in the folder — which is
       what "last saved" should mean for a portfolio assembled from several files. */
    + `<div class="header-meta ov-meta">`
      + `<span id="portfolioLastSaved">${_portfolioLastSavedHtml()}</span>`
      + `<span style="opacity:0.6">${_escapeHtml(APP_VERSION)}</span><br>`
      + `<span class="ov-datasrc${_dataSrcState().warn ? ' ov-datasrc-warn' : ''}" id="pfDataSrc">${_dataSrcInnerHtml()}</span>`
      + `</div>`
    + `</div><div class="pf-bar">`
    /* v14.3 (a): the pane switch first, so it reads as what it is - which portfolio view you
       are looking at, not another action. v14.4 (a): the third entry. */
    + `<span class="pf-switch">`
      + `<button onclick="setPortfolioPane('programmes')" aria-pressed="${_progs ? 'true' : 'false'}">Programmes</button>`
      + `<button onclick="setPortfolioPane('activity')" aria-pressed="${_act ? 'true' : 'false'}">Activity</button>`
      + `<button onclick="setPortfolioPane('improvement')" aria-pressed="${_ci ? 'true' : 'false'}">Continuous improvement</button>`
    + `</span>`
    /* ⚠ v14 (W8, ◆3): IN THE VIEWER THE ACTIONS ARE EMPTY — every control here writes or binds:
       "+ New programme" creates a record that can never be saved, Import merges into a portfolio
       with nowhere to go, and "Change folder" binds a handle in a mode where Save refuses.
       Offering them beside a banner that says saving is off is the app arguing with itself.
       Export is a read operation, but with nothing loaded there is nothing to export.
       ⚠ And every control below WRITES or BINDS, so the Activity and Continuous improvement
       panes show none of them - a read view offers no write controls. */
    + `<span class="pf-actions">`
    /* v12.3 (W4): the approved mockup’s order - + New programme · Import · Export · Change data
       file. Export is offered only when the FILE holds projects (the same gate it had on the
       programme view, just evaluated portfolio-wide, which is what it always measured anyway). */
    + (_progs ? _listOrderControlsHtml('programme', '') : ``)
    + (_progs ? `<button class="ov-btn ov-btn-primary" onclick="pfNewProgramme(this)">+ New programme</button>` : ``)
    + (_progs ? `<button class="ov-btn" onclick="openImport()">Import</button>` : ``)
    + ((_progs && (((window.__DB__ || {}).projects) || []).length)
        ? `<button class="ov-btn" onclick="openExport()">Export</button>` : ``)
    + ((_progs && !_searching && arch.length) ? `<label class="ov-arch-toggle"><input type="checkbox" id="pfShowArchived" onchange="pfToggleArchived(this)"${_pfShowArchived ? ' checked' : ''}> Show archived (${arch.length})</label>` : '')
    + `</span></div>`
    + `<div id="portfolioFileState">${_dataFileBannersHtml()}</div>`
    + (_act ? _activityHtml() : _ci ? _ciPaneHtml() : listHtml)
    + `</div>`;
  const activityInput = host.querySelector('#actSearch');
  if (activityInput) {
    activityInput.addEventListener('input', function (event) { actSearchInput(this, event); });
    activityInput.addEventListener('compositionstart', function () { this._actComposing = true; });
    activityInput.addEventListener('compositionend', function () { this._actComposing = false; actSearchInput(this); });
  }
  if (selection) {
    const input = document.getElementById('actSearch');
    if (input) { input.focus({ preventScroll: true }); input.setSelectionRange(...selection); }
  }
}
/* ── v10.5 (◆2), kept: the bound file could not be restored — land on the PORTFOLIO ───
   Boot loads the sibling file via <script src>, and only then does the handle-restore
   chain adopt the BOUND file. When that adopt cannot happen — the file is unreadable
   (catch), or the browser wants a click before granting permission (else) — the
   bootstrap file's data is what is left on screen. Under v11 that is the whole portfolio
   wearing the wrong identity, so it matters more, not less.
   v10.3's W2 fixed the SAVE-SAFETY half of this state and left the DISPLAY half;
   v10.5's ◆2 completed it. Both branches call this. */
function _fallbackToPortfolio() {
  /* Only ever take over a LANDING view. A user who navigated into a project while the
     restore was still in flight must not be yanked out of it. */
  if (document.body.classList.contains('view-portfolio')) { renderPortfolio(); return; }
  if (document.body.classList.contains('view-overview')) gotoPortfolio();
}

function showPortfolio() {
  if (!_progressPermitRoute('#/portfolio')) return false;
  _disposeActionLabels();
  _settleStakeholderCards();
  _closeStakeholderMenus();
  _progressHelpClose();
  document.body.classList.remove('view-overview');
  document.body.classList.remove('view-focus');
  document.body.classList.add('view-portfolio');
  _renderLocationRail('portfolio');
  document.title = 'Programmes — TrendAI FlightDeck';
  if (_pfPane === 'programmes') _reorderUiBind('programme', '');
  else _reorderUiReset();
  renderPortfolio();   /* straight from memory — nothing to await */
  _refreshFileAlerts();   /* v11.1 (W2): clears the strip — this view owns the real thing */
  return true;
}

